import { HubRoutingWardViewModel } from "./index";

export class GetDatasFromHubViewModel {
    selectedWardIds: number[];
    wards: HubRoutingWardViewModel[];
}


// WEBPACK FOOTER //
// D:/SSW/Project/GSDP/Angular/gsdp_core_angular/src/app/view-model/getDatasFromHub.viewModel.ts